﻿(function ($, document, undefined) {
    window.SetupProductCarousel = function ($htmlElement) {
        if (!$htmlElement.length) {
            return;
        }

        if ($htmlElement.find('> li').length < 4) {
            return;
        }

        $htmlElement.slick({
            slidesToShow: 3,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ],
            prevArrow: '<div type="button" class="slick-prev"><img src="/CMSGlobalFiles/Img/Icons/carousel-arrow.svg" class="carousel prev arrow arrow--normal" /><img src="/CMSGlobalFiles/Img/Icons/carousel-arrow--filled.svg" class="carousel prev arrow arrow--hover" /></div>',
            nextArrow: '<div type="button" class="slick-next"><img src="/CMSGlobalFiles/Img/Icons/carousel-arrow.svg" class="carousel next arrow arrow--normal" /><img src="/CMSGlobalFiles/Img/Icons/carousel-arrow--filled.svg" class="carousel next arrow arrow--hover" /></div>'
        });
    }

    $(document).ready(function () {
        SetupProductCarousel($('[data-product-carousel]'));
    });

})(jQuery, document);